import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import { queryStringToObj } from "../../../../Utility";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'transparent',
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme?.agentTheme?.card?.link_foreground,
  },
  inputRoot: {
    color: theme?.agentTheme?.card?.link_foreground,
    width: "100%",
  },
  inputInput: {
    padding: theme.spacing(1, 7, 1, 1),
    transition: theme.transitions.create("width"),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 0, 1, 1),
    },
  },
}));

export default ({ username = null }) => {
  const classes = useStyles();
  const [searchVal, setSearchVal] = useState("");
  let location = useLocation();
  let searchParams = queryStringToObj(location.search);

  useEffect(() => {
    setSearchVal(searchParams.q);
    if (!("q" in searchParams)) setSearchVal("");
  }, [location.search]);

  const handleSearch = () => {
    if (searchVal) {
      window.location = username
        ? `/${username}/packages/?&q=${searchVal}`
        : `/packages/?&q=${searchVal}`;
    }
  };

  const keyPress = (e) => {
    if (e.keyCode == 13) {
      handleSearch();
    }
  };

  return (
    <div className={classes.search}>
      <InputBase
        placeholder="Destination"
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        inputProps={{ "aria-label": "search" }}
        onChange={(e) => setSearchVal(e.target.value)}
        onKeyDown={keyPress}
        value={searchVal}
        startAdornment={
          <InputAdornment position="end">
            <IconButton onClick={handleSearch}>
              <SearchIcon classes={{ root: classes.searchIcon }} />
            </IconButton>
          </InputAdornment>
        }
      />
    </div>
  );
};
